/**
 * 静态文件 CDN 域名：
 * - 正式站 mp.infiniax.com → file-pub
 * - 其余环境 → file-uat
 */
const PROD_HOST = "mp.infiniax.com";
const FILE_CDN_PROD = "https://file-pub.infiniax.com";
const FILE_CDN_UAT = "https://file-uat.infiniax.com";

export function getFileCdnOrigin() {
  const host =
    (typeof location !== "undefined" && location.hostname) || "";
  return host === PROD_HOST ? FILE_CDN_PROD : FILE_CDN_UAT;
}

export const FILE_CDN_ORIGIN = getFileCdnOrigin();

/**
 * 拼接文件 CDN 完整地址
 * @param {string} path 如 "/template/a.xlsx" 或 "template/a.xlsx"；也可传入完整 URL（会改写域名）
 */
export function fileCdnUrl(path = "") {
  const raw = String(path || "");
  if (/^https?:\/\//i.test(raw)) {
    return raw
      .replace(/^https?:\/\/file-pub\.infiniax\.com/i, FILE_CDN_ORIGIN)
      .replace(/^https?:\/\/file-uat\.infiniax\.com/i, FILE_CDN_ORIGIN);
  }
  const normalized = raw.startsWith("/") ? raw : `/${raw}`;
  return `${FILE_CDN_ORIGIN}${normalized}`;
}

export default fileCdnUrl;
